/* Vertical spacing component meant as an escape hatch */
import React from "react";
import styled from "styled-components";

export default styled.div`
  height: ${({ span }) => span + "rem"};
`;



// WEBPACK FOOTER //
// ./src/components/blocks/Spacer.js